'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import { SignupFlows, SignupFlowToPath } from './constants/SignupFlows';
import AllowedIntents from './constants/AllowedIntents';
import IntentsToPath from './constants/IntentsToPath';
import UtmsToPath from './constants/UtmsToPath';
import HubsToPath from './constants/HubsToPath';
import OptsToPath, { OptsToValue } from './constants/OptsToPath';
var SIGNUP_ROOT_PATH = '/signup';
var ODYSSEY_SIGNUP_ROOT_PATH = '/signup-hubspot';
var DEFAULT_SIGNUP_PATHNAME = ODYSSEY_SIGNUP_ROOT_PATH + "/crm";
var SIGNUP_TYPES_ON_ODYSSEY = [SignupFlows.CLASSROOM_TRAINING, SignupFlows.CRM, SignupFlows.SERVICE, SignupFlows.SALES, SignupFlows.MARKETING];

var buildQueryParams = function buildQueryParams(query) {
  var queries = [];
  var orderedKeys = Object.keys(query).sort();
  orderedKeys.forEach(function (queryKey) {
    if (query.hasOwnProperty(queryKey)) {
      var queryValue = query[queryKey];

      if (queryValue) {
        // should we ever push empty param & values?
        queries.push(encodeURIComponent(queryKey) + "=" + encodeURIComponent(queryValue));
      }
    }
  });
  return queries.length ? "?" + queries.join('&') : '';
};

var getPathFromFlow = function getPathFromFlow(signupFlow) {
  if (SignupFlows.hasOwnProperty(signupFlow) && SignupFlowToPath.hasOwnProperty(signupFlow)) {
    return SignupFlowToPath[signupFlow];
  }

  console.error('Couldn`t find signup flow, defaulting to crm');
  return SignupFlowToPath[SignupFlows.CRM];
};

var getIntentPathFromIntent = function getIntentPathFromIntent(intentParam) {
  if (AllowedIntents.hasOwnProperty(intentParam) && IntentsToPath.hasOwnProperty(intentParam)) {
    return IntentsToPath[intentParam];
  }

  console.error("Couldn`t find intent for " + intentParam + ", leaving empty");
  return null;
};

var getParamPathFromParam = function getParamPathFromParam(param) {
  var paramToPathMap = Object.assign({}, OptsToPath, {}, HubsToPath, {}, UtmsToPath);
  var path = paramToPathMap[param];

  if (!path) {
    console.error("Couldn`t find mapping for " + param + ", leaving empty");
  }

  return path;
};

var getSignupRootPath = function getSignupRootPath(signupFlow) {
  if (SignupFlows.hasOwnProperty(signupFlow) && SignupFlowToPath.hasOwnProperty(signupFlow)) {
    return SIGNUP_TYPES_ON_ODYSSEY.includes(signupFlow) ? ODYSSEY_SIGNUP_ROOT_PATH : SIGNUP_ROOT_PATH;
  }

  return ODYSSEY_SIGNUP_ROOT_PATH;
};

var SignupUrlGenerator = /*#__PURE__*/function () {
  function SignupUrlGenerator(signupFlow) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, SignupUrlGenerator);

    this.shouldUpdateOptions = true;
    this.signupFlow = signupFlow;
    this.options = options || {};

    if (!this.options.query) {
      this.options.query = {};
    }

    try {
      var signupRoute = getPathFromFlow(this.signupFlow);
      this.signupPathname = getSignupRootPath(this.signupFlow) + "/" + signupRoute;
      this.signupQueryParams = this.updateOptions(options);
    } catch (error) {
      this.signupPathname = DEFAULT_SIGNUP_PATHNAME;
      this.signupQueryParams = '';
    }
  }

  _createClass(SignupUrlGenerator, [{
    key: "updateOptions",
    value: function updateOptions(options) {
      var updated = options.query ? buildQueryParams(options.query) : '';
      this.shouldUpdateOptions = false;
      return updated;
    }
  }, {
    key: "getPathname",
    value: function getPathname() {
      return this.signupPathname;
    }
  }, {
    key: "getSearch",
    value: function getSearch() {
      if (this.shouldUpdateOptions) {
        this.signupQueryParams = this.updateOptions(this.options);
        this.shouldUpdateOptions = false;
      }

      return this.signupQueryParams;
    }
  }, {
    key: "getUrl",
    value: function getUrl() {
      return "" + this.signupPathname + this.getSearch();
    }
  }, {
    key: "withIntent",
    value: function withIntent(intent) {
      var value = getIntentPathFromIntent(intent);

      if (value) {
        this.options.query.intent = value;
        this.shouldUpdateOptions = true;
      }

      return this;
    }
  }, {
    key: "withParam",
    value: function withParam(param, paramValue) {
      var key = getParamPathFromParam(param);

      if (key) {
        this.options.query[key] = paramValue || OptsToValue[param];
        this.shouldUpdateOptions = true;
      }

      return this;
    }
  }, {
    key: "withUtm",
    value: function withUtm(utm, utmValue) {
      return this.withParam(utm, utmValue);
    }
  }, {
    key: "withHubs",
    value: function withHubs(hubs, hubsValue) {
      return this.withParam(hubs, hubsValue);
    }
  }, {
    key: "withOption",
    value: function withOption(option) {
      return this.withParam(option);
    }
  }]);

  return SignupUrlGenerator;
}();

export { SignupUrlGenerator as default };